var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import SystemSettingsService from '../../../api/SystemSettingsService';
import VueDialog from "../../../interface/IVueDialog";
var EditDialog = (function (_super) {
    __extends(EditDialog, _super);
    function EditDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = {
            channel: '',
            payment_type: 14,
            payment_type_name: '',
            app_id: '',
            mch_id: '',
            is_open: 1,
            app_secret: '',
            pay_url: '',
            payment_config: {
                is_open_official: 0,
                app_id: "",
                secret: ""
            },
        };
        _this.payment_type_options = [];
        _this.payment_pass_options = [];
        return _this;
    }
    EditDialog.prototype.created = function () {
        if (this.isEdit) {
            this.initFormData(this.data);
        }
        this.service = SystemSettingsService.getInstance();
    };
    EditDialog.prototype.mounted = function () {
        this.getPayTypeList();
        this.getPayPass();
    };
    EditDialog.prototype.getPayTypeList = function () {
        var _this = this;
        this.service.getPayTypeList().then(function (res) {
            if (res.data && res.data.success) {
                _this.payment_type_options = res.data.data;
            }
        });
    };
    EditDialog.prototype.getPayPass = function () {
        var _this = this;
        this.service.getPayPass().then(function (res) {
            if (res.data && res.data.success) {
                _this.payment_pass_options = res.data.data;
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    EditDialog.prototype.initFormData = function (data) {
        this.formData = {
            channel: data.channel,
            payment_type: data.payment_type,
            payment_type_name: data.payment_type_name,
            app_id: data.app_id,
            mch_id: data.mch_id,
            is_open: data.is_open,
            app_secret: data.app_secret,
            pay_url: data.pay_url,
            payment_config: data.payment_config,
        };
        this.payment_config_id = data.payment_config_id;
    };
    EditDialog.prototype.close = function () {
        this.$closeDialog();
    };
    EditDialog.prototype.confirm = function () {
        if (this.isEdit) {
            Object.assign(this.formData, {
                payment_config_id: this.payment_config_id
            });
        }
        this.addOrModifyAjax(this.formData, this.isEdit);
    };
    EditDialog.prototype.addOrModifyAjax = function (params, isEdit) {
        var _this = this;
        if (isEdit === void 0) { isEdit = false; }
        var payload = __assign({}, params);
        payload.payment_config = JSON.stringify(payload.payment_config);
        var promiseResult = isEdit ? this.service.editPay(payload) : this.service.addPay(payload);
        var successMsg = isEdit ? '编辑成功' : '添加成功';
        promiseResult.then(function (res) {
            if (res.data && res.data.success) {
                _this.$message.success(res.data.msg || successMsg);
                _this.$emit('editDialog:ok');
                _this.$closeDialog();
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }).catch(function (error) {
            _this.$message.error(error.msg || error.message);
        });
    };
    EditDialog = __decorate([
        Component
    ], EditDialog);
    return EditDialog;
}(VueDialog));
export default EditDialog;
